import { DateRangeParameterDTO } from './../../../../../base/models/models.swagger.generated';
import { DataManager } from '@syncfusion/ej2-data';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GridComponent, GridModule } from '@syncfusion/ej2-angular-grids';
import { DateTime } from 'luxon';
import { UserExtractReportSummaryDTO, Currency } from 'src/app/base/models/models.swagger.generated';
import { ClientService } from 'src/app/base/services/client/client.service';
import { StringHelper } from 'src/app/base/shared/string-helper';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { reportsRoute } from 'src/app/core/routing/route-names';
import { ReportsFooterComponent } from '../../../reports-footer/reports-footer.component';
import { SaveOptions } from '../../../reports-footer/save-options';
import { UserExtractReportService } from '../user-extract-report.service';
import { UserExtractFormType } from '../user-extract-form/user-extract-form-type';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf, NgFor, DecimalPipe } from '@angular/common';
import { UserExtractFormComponent } from '../user-extract-form/user-extract-form.component';
import { TitleBarComponent } from '../../../../../base/shared/title-bar/title-bar.component';

@Component({
    selector: 'app-user-extract-report',
    templateUrl: './user-extract-report.component.html',
    styleUrls: ['./user-extract-report.component.scss'],
    imports: [TitleBarComponent, UserExtractFormComponent, NgIf, GridModule, ReportsFooterComponent, NgFor, DecimalPipe, TranslateModule]
})
export class UserExtractReportComponent implements OnInit {
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild(ReportsFooterComponent) public footer: ReportsFooterComponent;

  public Currency = Currency;
  public data: DataManager;
  public summaryData: UserExtractReportSummaryDTO;

  public filterForm: FormGroup<UserExtractFormType> = this.fb.group<UserExtractFormType>({
    startDate: this.fb.control(DateTime.now().startOf('month').toJSDate()),
    endDate: this.fb.control(DateTime.now().endOf('month').toJSDate())
  });

  public pageSettings = GridConstantsFactory.createStandardPageSettings();

  constructor(public clientService: ClientService,
              private fb: FormBuilder,
              private router: Router,
              private spinnerService: SpinnerService,
              private userExtractReportService: UserExtractReportService) {
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.userExtractReportService, this.spinnerService),
    });

    this.searchReports();
  }

  public searchReports(): void {
    if (this.filterForm.controls.startDate.value && this.filterForm.controls.endDate.value) {
      const reportParameters = this.createReportParameters();
      this.userExtractReportService.reportParameters = reportParameters;
      this.grid?.refresh();
      this.userExtractReportService.getReportSummary(reportParameters)
        .subscribe(summary => {
          this.summaryData = summary;
          this.summaryData.totalAmounts.sort((a, b) => a.currency - b.currency);
        });
    }
  }

  public saveReport(saveOptions: SaveOptions): void {
    this.spinnerService.showSpinner = true;
    const reportParameters = this.createReportParameters();
    this.userExtractReportService.exportReport(reportParameters, saveOptions)
      .subscribe(savedReportFileDTO => {
        this.spinnerService.showSpinner = false;
        if (saveOptions.saveReport) {
          this.router.navigate([reportsRoute]);
        } else {
          this.footer.downloadFile(savedReportFileDTO);
        }
      });
  }

  public formatTime(minutes: number): string {
    return StringHelper.transformToTimeRepresentation(minutes);
  }

  public formatCurrency(type: Currency): string {
    if (type == null) {
      return '';
    }
    return 'i18n.shared.currencies.' + Currency[type];
  }

  private createReportParameters(): DateRangeParameterDTO {
    return new DateRangeParameterDTO({
      startDate: DateTime.fromJSDate(this.filterForm.controls.startDate.value).startOf('day').toFormat('yyyy-MM-dd'),
      endDate: DateTime.fromJSDate(this.filterForm.controls.endDate.value).startOf('day').toFormat('yyyy-MM-dd'),
    });
  }
}
